/**
 * Wraps address1 text to address2 if it exceeds maxLength, breaking at word boundaries
 * @param {string} address1 - The address1 text
 * @param {string} address2 - The existing address2 text
 * @param {number} maxLength - Maximum length for address1
 * @returns {object} - { address1, address2 } with wrapped text
 */
export const wrapAddress1ToAddress2 = (address1, address2, maxLength) => {
  if (!address1 || address1.length <= maxLength) {
    return { address1, address2 };
  }

  // Find the last space before maxLength
  let breakPoint = address1.lastIndexOf(' ', maxLength);
  
  // If no space found or too close to start, just cut at maxLength
  if (breakPoint === -1 || breakPoint < maxLength * 0.5) {
    breakPoint = maxLength;
  }

  const wrappedAddress1 = address1.substring(0, breakPoint).trim();
  const overflow = address1.substring(breakPoint).trim();
  
  // Prepend overflow to address2 if it exists
  const wrappedAddress2 = overflow + (address2 ? ' ' + address2 : '');

  return {
    address1: wrappedAddress1,
    address2: wrappedAddress2
  };
};
